import { Keyboard } from '@ionic-native/keyboard/ngx';
import { Location } from '@angular/common';
import { SessionDataService } from './../../../../redux/session/session-data-service';
import { SessionInfo } from './../../../../data/authentication-info';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { adjustViewZIndex } from 'src/globals';
import { CompetitionService } from './../../../../providers/competition-service/competition-service';
import {
  CompetitionPlayerInfo,
  CompetitionInfo,
  CompetitionCategory,
} from './../../../../data/competition-data';
import { AuthenticationService } from './../../../../authentication-service';
import { RemoteHttpService } from './../../../../remote-http';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ActionSheetController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import { isBlank } from 'src/providers/common-service';
import { ImageZoomPage } from '../../modal-screens/image-zoom/image-zoom.page';
import { CompetitionData, GameRoundInfo, PlayerInfo, CompetitionRoundSession, PlayerDataLite, CompetitionPlayerData } from 'src/data/mygolf.data';
import { JsonService } from 'src/json-util';
import { PlayerService } from 'src/providers/player-service/player-service';
import { ProfilePage } from '../../profile/profile.page';
import { Observable, observable, of } from 'rxjs';

import * as moment from 'moment';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { DescriptionModalPage } from '../competitions-modal/description-modal/description-modal.page';
import * as global from 'src/globals';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
// import {Keyboard} from '@ionic-native/keyboard';
// CompetitionPlayerInfo,
export interface PlayerSession extends CompetitionPlayerData {
  session?: any; //CompetitionRoundSession;
}
@Component({
  selector: 'app-competition-players',
  templateUrl: './competition-players.page.html',
  styleUrls: ['./competition-players.page.scss'],
})
export class CompetitionPlayersPage implements OnInit {
  appFooterHide: boolean = true;
  //private actionSheet: ActionSheet;
  public competition: CompetitionInfo & CompetitionData;
  public players: Array<CompetitionPlayerData> =
    new Array<CompetitionPlayerData>();
  public filteredPlayers: Array<PlayerSession> =//CompetitionPlayerInfo> =
    new Array<PlayerSession>();
  public roundNo: number;
  public visible: boolean;
  public searchQuery: string = '';

  public sortBy: string = 'name';
  public sortByBoolean: boolean;
  public sortByDisplay: string = '';
  public sortToggle: boolean = true;
  public categories: Array<CompetitionCategory> =
    new Array<CompetitionCategory>();
  public showCategoryName: string;

  compData: CompetitionData;
  compId: number;

  filteredByGroup: string;
  playerGroupsList: Array<CompetitionPlayerData>;

  constructor(
    private router: Router,
    public nav: NavController,
    private renderer: Renderer2,
    private keyboard: Keyboard,
    private toastCtl: ToastController,
    public navParams: NavParams,
    private http: RemoteHttpService,
    private loadingCtl: LoadingController,
    private actionSheetCtl: ActionSheetController,
    private auth: AuthenticationService,
    private platform: Platform,
    private sessionService: SessionDataService,
    private compService: CompetitionService,
    private route: ActivatedRoute,
    private location: Location,
    private modalCtl: ModalController,
    private playerService: PlayerService,
    private competitionService: CompetitionService,
    private flightService: ClubFlightService,
    private mg2uUtils: mygolfUtils,

  ) {
    if (!this.router.getCurrentNavigation().extras.state) {
      this.onHomeClick()
    }


    this.competition = this.router.getCurrentNavigation().extras.state.competition;
    this.compId = this.router.getCurrentNavigation().extras.state.compId;
    this.players = this.router.getCurrentNavigation().extras.state.players;
    this.roundNo = this.router.getCurrentNavigation().extras.state.roundNo;
    this.categories = this.router.getCurrentNavigation().extras.state.categories;
    this.visible = false;
    this.searchQuery = '';
    this.filteredPlayers = this.players;
    this.showCategoryName = 'All Categories';
    this.sortBy = 'name';
    this.sortByBoolean = false;
    this.sortByDisplay = 'Handicap';



    this.compData = this.competitionService.getCompData();
    this.onRefreshClick(null,null);

  }

  ionViewDidEnter() {
    adjustViewZIndex(this.nav, this.renderer);
  }

  ngOnInit() { }





  async onRefreshClick(filter, refresher) {
    let loader = await this.loadingCtl.create({
      message: 'Loading player list, Please wait...'
    });


    // this.compData = this.competitionService.getCompData();


    loader.present().then(() => {
      this.compService.getPlayersRegistered(this.compId, this.sortBy)
        .subscribe((players: any) => {
          loader.dismiss().then(() => {
            this.players = players;
            // this.filteredPlayers = this.players;
            // console.debug(" refresh players ", this.filteredPlayers, this.compData)
            if(this.compData?.gameRounds && this.compData?.gameRounds[0]?.sessions?.length > 0) {
              this._constructPlayerSessions();
              this.compRoundSession = this.compData?.gameRounds[0].sessions;
            }

            this.onSearchCancel();
            this.searchQuery = "";
            if (refresher) refresher.detail.complete();
          })
        }, (error) => {
          loader.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(error, "Error refreshing the registered players");
            MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
          })
        },
          () => {
            if (refresher) refresher.detail.complete();
            if (filter)
              this.onSearchInput(null);
            if (this.platform.is('ios') && this.platform.is('capacitor'))
              this.keyboard.hide();
          })
    });
    this.getRegisteredPlayers();

  }

  registeredPlayers: Array<CompetitionPlayerData> = [];
  getRegisteredPlayers() {

    this.flightService.getCompRegisteredPlayers(this.compId, this.sortBy)
    .subscribe((players: Array<CompetitionPlayerData>) => {
        this.registeredPlayers = players;
        this.filteredPlayers = players;
        this.playerGroupsList = this.mg2uUtils.getUnique(players, 'groupName');
        this.playerGroupsList.sort((a,b)=>{
          if(a < b) return -1;
          else if(a > b) return 1;
          else return 0;
        })
        this.playerGroupsList = this.playerGroupsList.filter((p)=>{ return p.groupName?.length})
        // console.debug(" refresh players ", this.filteredPlayers, this.compData)
        if(this.compData?.gameRounds && this.compData?.gameRounds[0]?.sessions?.length > 0) {
          this._constructPlayerSessions();
          this.compRoundSession = this.compData?.gameRounds[0].sessions;
        }

        this.onSearchCancel();
        this.searchQuery = "";
    }, (error) => {
        let msg = MessageDisplayUtil.getErrorMessage(error, "Error refreshing the registered players");
        MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");

    },
      () => {
      })
  }


  toggle(searchBar, search) {

    this.visible = searchBar;
    //searchBar.setFocus();
    if (this.visible) {

    }
  }

  onSearchCancel() {
    this.toggle(false, null);
  }

  onHomeClick() {
    this.router.navigate(['tabs/player-home']);
  }

  onSearchInput(searchbar) {
    // console.debug(" player session ", this.filteredPlayers, this.compData);
    if (this.searchQuery && this.searchQuery.length > 0)
      this.filteredPlayers = this.registeredPlayers.filter((p: CompetitionPlayerData) => {
        return (
          p?.player.playerName.toLowerCase().indexOf(this.searchQuery.toLowerCase()) >=
          0 || p?.groupName?.toLowerCase().indexOf(this.searchQuery.toLowerCase()) >= 0
        );
      });
    else this.filteredPlayers = this.registeredPlayers;
    this.showCategoryName = 'All Categories';
  }

  toggleSortDisplay(str: string) {
    // this.sortByBoolean = !this.sortByBoolean;
    // if (this.sortByBoolean) {
    //     this.sortBy        = 'handicap';
    //     this.sortByDisplay = 'Name';
    // }
    // else {
    //     this.sortBy        = 'name';
    //     this.sortByDisplay = "Handicap";
    // }
    if (this.sortBy == 'name') {
      this.sortBy = 'handicap';
      this.sortByDisplay = 'Name';
        this.sortToggle = true;
          this.onRefreshClick(true, null);
    } else if (this.sortBy == 'handicap') {
      this.sortBy = 'name';
      this.sortByDisplay = 'Handicap';
        this.sortToggle = false;
          this.onRefreshClick(true, null);
    }
    // if (this.sortBy !== str) {
    //   this.sortBy = str;
    //   this.onRefreshClick(true, null);
    // }
  }

  getSortBy(sortBy: string) {
    // defining class

    if (sortBy == 'name' && this.sortBy == 'name') return 'sortedBy';
    if (sortBy == 'handicap' && this.sortBy == 'handicap') return 'sortedBy';
  }

  public async onMenuSortClick() {

    let actionSheet = await this.actionSheetCtl.create({
      buttons: [
        {
          text: 'Sort By : ' + this.sortByDisplay,
          role: 'destructive',
          cssClass: 'sort-by',
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.toggleSortDisplay('');
            });


            return false;
          },
        },
        {
          text: 'Cancel',
          role: 'cancel', // will always sort to be on the bottom
          icon: !this.platform.is('ios') ? 'close' : null,
          handler: () => {

            actionSheet.dismiss();
            return false;
          },
        },
      ],
    });
    await actionSheet.present();
  }

  getFlagUrl(flagUrl: string) {
    if (flagUrl === null || isBlank(flagUrl)) return null;
    else {
      let flagIcon = flagUrl.split('/');
      // return "img/flag/"+flagUrl.split[2]
      return 'img/flag/' + flagIcon[2];
    }
  }

  public checkScoringCategory() {
    let hasScoringCategory: boolean = false;
    this.categories.forEach((c: CompetitionCategory) => {
      if (c.forGrouping) {

        hasScoringCategory = true;
        // return c.forGrouping
      }
    });
    return hasScoringCategory;
  }

  public async openCategory() {

    let buttons: any = [
      {
        text: 'Cancel',
        role: 'cancel', // will always sort to be on the bottom
        icon: !this.platform.is('ios') ? 'close' : null,
        handler: () => {
          actionSheet.dismiss();
          return false;
        },
      },
    ];


    let tempCategoryName = '';
    if (this.categories.length > 0) tempCategoryName = 'All Categories';
    else tempCategoryName = 'No Category';



    buttons.push(
      {
        text: tempCategoryName,
        role: 'destructive',
        icon: 'filter',
        handler: () => {
          actionSheet.dismiss()
            .then(() => {
              //   this.selectedCategoryId = "";
              //   this._setLeaderboardFilter();


              this.showCategoryName = tempCategoryName
              this.filteredPlayers = this.players;
            });
          return false;
        }
      }
    );


    this.categories.forEach((c: CompetitionCategory) => {


      if (c.forGrouping) {
        buttons.push({
          text:
            c.categoryName + ' (' + c.fromHandicap + ' - ' + c.toHandicap + ')',
          role: 'destructive',
          icon: 'filter',
          handler: () => {
            actionSheet.dismiss().then(() => {

              this.showCategoryName =
                c.categoryName +
                ' (' +
                c.fromHandicap +
                ' - ' +
                c.toHandicap +
                ')';
              this.filteredPlayers = this.players.filter(
                (p: CompetitionPlayerData) => {
                  return p.category === c.categoryName;
                }
              );
              //   this.selectedCategoryId = String(c.categoryId);
              //   this._setLeaderboardFilter();
            });
            return false;
          },
        });
      }
    });



    let actionSheet = await this.actionSheetCtl.create({
      buttons: buttons
    });

    actionSheet.present();
  }

  onBackpage() {

    this.location.back();
    // this.router.navigate(['tabs/competition-details']);
  }
  goHome() {

    this.router.navigate(['tabs/player-home']);
  }
  async onZoomImage(item: CompetitionPlayerInfo & any, type: string) {
    if (!item) return;
    let _description = "";
    let _image = '';
    if (type === 'country') {
      // console.debug('on zoom image [0]: ', this.getFlagUrl(item.nationalFlag));
      // console.debug('on zoom image [1]: ', item?.player?.nationality?.flagUrl);
      // console.debug('on zoom image [2]: ', this.getFlagUrl(item?.player?.nationality?.flagUrl));
      if(this.getFlagUrl(item.nationalFlag))
      _image = 'assets/'  + this.getFlagUrl(item.nationalFlag)
      else if(this.getFlagUrl(item?.player?.nationality?.flagUrl))
        _image = 'assets/'  + this.getFlagUrl(item?.player?.nationality?.flagUrl)
      else _image = 'assets/image/' + 'flag/default_worldwide.png'
      if(item?.nationalityName)
        _description = item.playerName + (item.nationalityName ? '<br>' + item.nationalityName : '');
      else _description = item?.player?.playerName + (item?.player?.nationality?.name ? '<br>' + item?.player?.nationality?.name : '');
    } else if(type === 'player') {
      // console.debug("zooming image ", item, type, this.getPlayerImage(item))
      if(item?.photoUrl)
        _image = item.photoUrl;
      else if(this.getPlayerImage(item))
        _image = this.getPlayerImage(item)
      _description = item.playerName? item.playerName : '';
    }

    // console.debug(" zoom image ", type, _image, item)


    const modal: any = await this.modalCtl.create(
      {
        component: ImageZoomPage,
        cssClass: 'self-adjustable-modal',
        componentProps: {
          image: _image,
          description: _description,
          descTopDown: 'top'
        }
      });
    await modal.present();
  }

  onShowPlayerDetails(event, item: PlayerInfo) {
    let _playerId = item.playerId;
    this.getPlayerInfo(_playerId)
      .then(async (result: any) => {
        if (result && result.status === 'success') {
          let _player;
          if (result.data) {
            _player = result.data;
            JsonService.deriveFulImageURL(_player, 'thumbnail');
            // JsonService.deriveFulImageURL(_player,'photoUrl');
          }

          let modal = await this.modalCtl.create({
            component: ProfilePage,
            componentProps: {
              status: 'view',
              type: 'viewProfile',
              player: of(_player),
              openedModal: true
            }
          });
          await modal.present();
        }

      }).catch(() => { })
  }
  getPlayerInfo(playerId: number) {
    return new Promise((resolve, reject) => {
      this.playerService.getPlayerInfo(playerId)
        .subscribe((playerInfo: PlayerInfo) => {
          if (playerInfo) {
            resolve({
              status: 'success',
              data: playerInfo
            })
          }
        }, (error) => {
          reject({
            status: 'failed',
            data: error,
            error: error
          })

        }, () => {
        })
    })
  }


  showHandicap() {
    // console.debug("show handicap check : ", this.compData)
    // if(!this.compData) return;
    if(this.compData?.proCompetition) return false;
    if(this.compData?.status === 'Completed') return true;
    if(!this.compData?.handicapFormat) return true;
    if(this.compData?.totalRounds <= 1) {
      if(this.compData?.handicapFormat) {
        if(this.compData?.handicapFormat?.name.toLowerCase().includes('peoria') || this.compData?.handicapFormat?.name.toLowerCase() === 'system36') {
          return false;
        } else return true;
      } else return true;
    } else if(this.compData?.totalRounds > 1) {
      let _round = this.compData.gameRounds.find((round: GameRoundInfo)=>{
        return round.roundNo === this.roundNo
      })
      if(_round?.status === 'Completed') return true;
      else {
        if(this.compData?.handicapFormat) {
          if(this.compData?.handicapFormat?.name.toLowerCase().includes('peoria') || this.compData?.handicapFormat?.name.toLowerCase() === 'system36') {
            return false;
          } else return true;
        } else return true;
      }
    }
  }

  _constructPlayerSessions() {
    let _round = this.compData.gameRounds.find((gameRounds)=>{
      return gameRounds.roundNo === 1;
    })
    this.filteredPlayers.forEach((player: any & PlayerSession)=>{
      player.session = _round.sessions.find((session: CompetitionRoundSession)=>{
        let _playerSession = session.sessionPlayers.find((playerSession: PlayerDataLite)=>{
          // console.debug("construct player ", player, session)
          return playerSession.id === player?.player.playerId || playerSession.playerId === player?.player.playerId
        })
        return _playerSession;
      })
    })
  }


  selectedSession: CompetitionRoundSession;
  compRoundSession: Array<CompetitionRoundSession> = [];
  async onChangeSession() {
    let _dataList = [];

    _dataList.push({
      id: null,
      name: 'All Sessions',
    })
    this.compRoundSession.forEach((session: CompetitionRoundSession) => {
      let _sessionTime = moment(session.startTime,'HH:mm:ss').format('hh:mm A');
      let _playerCount = 0 || session.sessionPlayers?.length;
      _dataList.push({
        id: session.sessionId,
        name: `${_sessionTime} (${_playerCount} / ${session.maxSlots})`
      })
    });

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
          app: null,
          dataList: _dataList,
          headerTitle: 'Filter by Session',
          mode: 'common',
      }
    })
    await modal.present().then(() => {
        const height = this.platform.height() - 250;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug("pullup dismiss", data, this.compRoundSession, this.filteredPlayers)
      if(data?.data) {
        this.selectedSession = this.compRoundSession.find((session)=>{
          if(data?.data?.id)
            return session.sessionId === data.data.id
          else return null;
        });
      }
    })
  }

  getSessionFilterInfo() {
    if(!this.selectedSession) return 'All Sessions';
    let _sessionTime = moment(this.selectedSession.startTime,'HH:mm:ss').format('hh:mm A');
    let _playerCount = 0 || this.selectedSession.sessionPlayers?.length;
    return `Session : ${_sessionTime} (${_playerCount} / ${this.selectedSession.maxSlots})`
  }
  getSessionInfo(session) {
    if(!session) return '';
    let _sessionTime = moment(session.startTime,'HH:mm:ss').format('hh:mm A');
    return `${_sessionTime}`
  }

  getFilteredPlayers() {
    let _filtered = [];
    if(this.filteredPlayers?.length) _filtered = this.filteredPlayers;
    // console.debug("filtered players [0]: ", this.filteredPlayers, _filtered)
    // console.debug("filtered players [1]: ", this.filteredByGroup)
    // console.debug("filtered players [2]: ", this.selectedSession, this.compRoundSession)
    if(this.selectedSession) {
      _filtered = _filtered.filter((ps)=>{
        return this.selectedSession?.sessionPlayers.some((sp)=>{
          return sp?.id === ps?.player?.id
        })
        // return ps?.session?.sessionId === this.selectedSession?.sessionId
      })
    }
    if(this.filteredByGroup) {
      _filtered = _filtered.filter((ps)=>{
        return ps?.groupName === this.filteredByGroup
      })
    }
    return _filtered;
  }

  parsePlayerStatus(player: PlayerSession) {
    if(!player) return;
    if(player.status === 'Registered') {
      return '';
    } else if(player.status === 'FailedCutoff') {
      return 'CUT';
    } else if(player.status === 'Withdrawn') {
      return 'Withdrawn';
    } else return player.status
  }

  getPlayerDetails(player: PlayerSession, attribute?: string) {
    if(!player) return;
    let _registeredPlayer = this.registeredPlayers.find((cp: CompetitionPlayerData)=>{
      return player.id === cp.id
    })
    switch(attribute) {
      case 'hidx':
        return _registeredPlayer?.handicapIndex;
    }
  }




  async morePlayersOptions(){

    // this.sortBy = 'name';
    // this.sortByDisplay = 'Handicap';
    let _dataList = [{
    id: 'refresh',
    name: 'Refresh',
    iconUrl: 'assets/icons/golf-website.png'
  },{
    id: 'toggleSort',
    name: `Sort by ${this.sortByDisplay}`,
    iconUrl: 'assets/icons/book.png'
  }
  // ,{
  //   id: 'lowestAverage',
  //   name: 'Lowest Average',
  //   iconUrl: 'assets/icons/golf-field.png'
  // }
]
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
          app: null,
          dataList: _dataList,
          mode: 'common',
          headerTitle: 'Players Options',
      }
  })
  await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
  });
  modal.onDidDismiss().then((data: any) => {
    console.debug("pullup dismiss", data)
    if(data) {
      if(data?.data?.id === 'refresh') {
        this.onRefreshClick(false,null);
      } else if(data?.data?.id === 'toggleSort') {
        this.toggleSortDisplay(null);
      }
    }
    // if(data)

  })
  }


  getPlayerImage(player) {
    // console.debug("get player image [0] : ", player)
    if (!player) return 'assets/image/default_user.png';
    let _playerImage = '';
    if (player.image) _playerImage = player.image;
    else if (player.profile) _playerImage = player.profile;
    else return 'assets/image/default_user.png';

    // console.debug("get player image [1] : ", global.MygolfServerHost + '/' + _playerImage);
    if(_playerImage.toLowerCase().includes(global.MygolfServerHost.toLowerCase()))
      return _playerImage
    else return global.MygolfServer + '/' + _playerImage;
  }


  async onChangeFilterByGroup() {
    let _dataList = [];
    _dataList.push({
      id: null,
      name: 'All Groups',
    })

    this.playerGroupsList.forEach((group: CompetitionPlayerData) => {
      if(group?.groupName)
        _dataList.push({
          id: group.groupName,
          name: group.groupName,
        })
    })

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
          app: null,
          dataList: _dataList,
          headerTitle: 'Filter by Group',
          mode: 'common',
      }
    })
    await modal.present().then(() => {
        const height = this.platform.height() - 250;
        if(document.getElementsByClassName('inner-content')[0])
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug("pullup dismiss", data)
      if(data?.data) {
        this.filteredByGroup = data.data.id;
        // this.selectedSession = this.compRoundSession.find((session)=>{
        //   if(data?.data?.id)
        //     return session.sessionId === data.data.id
        //   else return null;
        // });
      }
    })
  }
}
